import { Sound } from "@cc/soundjs-manager";
import { AssetLoader } from "./AssetLoader";

/**
 */
export const LoaderMiddleware: ((...params: any[]) => any)[] = [
  /**
   * Spine resources
   */
  function(resource: PIXI.LoaderResource, next: Function): any {
    if (resource.spineData) {
      AssetLoader.spineResources.push(resource);
    }
    next();
  },

  /**
   * Audio sprite JSON data resources loaded with createjs.SoundJS
   */
  function(resource: PIXI.LoaderResource, next: Function): any {
    if (resource.data && resource.data.data && resource.data.data.audioSprite) {
      if (!(createjs as any).Sound) {
        console.log("Tried to load audio sprite data but createjs.SoundJS is not declared.");
        next();
      }
      const Sound = (createjs as any).Sound;
      resource.data.src = AssetLoader.baseUrl + resource.data.src;
      Sound.registerSounds([resource.data]);
      Sound.on("fileload", (e: any) => {
        if (resource.data.src === e.src) next();
      });
      Sound.on("fileerror", (e: any) => {
        if (resource.data.src === e.src) {
          console.log(e);
          next();
        }
      });
    } else next();
  }
];

/**
 */
export const LoaderMiddlewarePre: ((...params: any[]) => any)[] = [
  function(resource: PIXI.LoaderResource, next: Function): any {
    const metadata: any = resource.metadata;
    if (metadata && metadata.isSoundAsset) {
      const sound: Sound = metadata.sound;
      resource.abort("");
      if (sound.state === "loaded") {
        next();
      } else {
        let r = false;
        const _next = () => {
          if (!r) next();
          r = true;
        };
        sound.off("load");
        sound.off("loaderror");
        sound.once("load", () => _next());
        sound.once("loaderror", () => _next());
        sound.load();
      }
    } else {
      next();
    }
  }
];
